import React, { useId } from 'react'
import PropTypes from 'prop-types'
import { Popover as PopOver, OverlayTrigger } from 'react-bootstrap'

const Popover = ({
  id = '',
  icon = 'fa-solid fa-circle-question',
  variant = 'primary',
  header,
  body,
  placement = 'right'
}) => {
  const popoverId = useId()
  let iconClass = `${icon} ps-2 pointer`
  if (variant) iconClass += ` text-${variant}`

  return (
    <OverlayTrigger
      rootClose
      trigger='click'
      key={id || popoverId}
      placement={placement}
      overlay={
        <PopOver id={`popover-${id || popoverId}`}>
          {header && <PopOver.Header as='h3'>{header}</PopOver.Header>}
          {body && <PopOver.Body>{body}</PopOver.Body>}
        </PopOver>
      }>
      <span className={iconClass} data-testid={id} />
    </OverlayTrigger>
  )
}

Popover.propTypes = {
  id: PropTypes.string,
  icon: PropTypes.string,
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  variant: PropTypes.string,
  header: PropTypes.string,
  body: PropTypes.string
}

export default Popover
